import { render, staticRenderFns } from "./dcc.vue?vue&type=template&id=33d357c0&scoped=true&v-once=true"
import script from "./dcc.vue?vue&type=script&lang=js"
export * from "./dcc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d357c0",
  null
  
)

export default component.exports